import { Loader2 } from 'lucide-react';
import { cn } from '@/ui/lib/utils';

interface SpinnerProps {
	className?: string;
	size?: 'sm' | 'md' | 'lg';
}

const SIZE = { sm: 'size-4', md: 'size-6', lg: 'size-8' };

export function Spinner({ className, size = 'md' }: SpinnerProps) {
	return (
		<Loader2
			className={cn(
				'animate-spin text-muted-foreground',
				SIZE[size],
				className,
			)}
		/>
	);
}
